import { useParams } from "react-router";
import { useGetWhoamiQuery } from "Services";
import { WhoamiGroup } from "Types";

const useGroup = (): WhoamiGroup | null => {
  const { groupId } = useParams();
  const { data: whoami } = useGetWhoamiQuery();

  return whoami?.org_groups.find((group) => group.group_id === groupId) ?? null;
};

export default useGroup;
